import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import { clientTypes } from 'appConstants';
import { useTranslation } from 'react-i18next';
import FullInfoField from 'components/FullInfoField/FullInfoField';

export const ClientTypeField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const { t } = useTranslation('form');

	const clientTypeName =
		clientTypes.find((el) => el.clientTypeID === restaurantForFullInfo?.restaurantType)?.clientTypeName || '';

	const inputValue = t(clientTypeName);

	return (
		<FullInfoField
			label="clientTypeLabel"
			value={inputValue}
			prefixIcon="asSelect"
			prefixIconName={clientTypeName}
		/>
	);
};
